import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ChildActivationEnd, NavigationEnd, Router } from "@angular/router";
import { Subject } from "rxjs";
import { buffer, filter, map, takeUntil, tap } from "rxjs/operators";
import { Spinner } from "src/app/core/services/spinner.service";
import { DOCSTORE_ROLES } from "src/app/shared/enums/admin-enum";
import { PATH_ROUTING } from "src/app/shared/enums/routing-enums";
import { Profile } from "src/app/shared/model/profile.model";
import { ProfileService } from "src/app/shared/service/profile.service";
import { DocStoreService } from "./services/docstore.service";

@Component({
  selector: "app-docstore",
  templateUrl: "./docstore.component.html",
  styleUrls: ["./docstore.component.scss"]
})
export class DocStoreComponent implements OnInit, OnDestroy {
  PATH_ROUTING = PATH_ROUTING;
  loginUser: Profile;
  isInCreateScreen: boolean;
  ngUnsubscribe$: Subject<any>;
  constructor(
    private spinner: Spinner,
    private docstoreService: DocStoreService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isInCreateScreen = false;
  }

  ngOnInit() {
    this.ngUnsubscribe$ = new Subject();
    this.setUpForIsInCreateDocumentScreen();
    this.profileService.getUserProfile().subscribe(profile => {
      this.loginUser = new Profile(profile);
    });
  }

  setUpForIsInCreateDocumentScreen() {
    if (this.firstInitWithCreateDocumentPage()) {
      this.isInCreateScreen = true;
    }
    const routeEndEvent$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd));

    this.router.events
      .pipe(
        filter(
          e => e instanceof ChildActivationEnd && e.snapshot.component === this.route.component
        ),
        buffer(routeEndEvent$),
        map(([ev]) => (ev as ChildActivationEnd).snapshot.firstChild.data),
        tap(data => (this.isInCreateScreen = data.action && data.action === "create")),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe();
  }

  firstInitWithCreateDocumentPage() {
    return (
      this.router.url === "/" + PATH_ROUTING.PATH_DOCSTORE + "/" + PATH_ROUTING.PATH_CREATE_CONTRACT
    );
  }

  isLoginUserViewer() {
    return this.loginUser.hasDocStoreRole(DOCSTORE_ROLES.DOCSTORE_VIEWER);
  }

  migrateDocuments(smartSheetFile: File) {
    if (!smartSheetFile) {
      return;
    }
    this.spinner.show();
    this.docstoreService.migrateDocuments(smartSheetFile).subscribe(response => {
      console.log(response);
      this.spinner.hide();
    });
  }
  
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
